module.exports = __webpack_public_path__ + "img/i-hospital-3.5c1dac2e.png";